"use client";
import { useState, useEffect, useRef } from "react";
import { useTenant } from "@/context/TenantContext";
import { getUser } from "@/services/auth";
import { getMyTenant } from "@/services/api";
import LegalConsentModal from "./LegalConsentModal";

interface PendingDoc {
  _id: string;
  type: "privacy" | "terms" | "security";
  title: string;
  content: string;
  version: number;
}

export default function LegalConsentTrigger() {
  const { loading } = useTenant(); // wait for auth + tenant to be ready
  const [docs, setDocs] = useState<PendingDoc[]>([]);
  const [showModal, setShowModal] = useState(false);
  const fetched = useRef(false);

  useEffect(() => {
    if (loading) return; // not ready yet
    if (fetched.current) return;

    const user = getUser();
    if (!user || (user.role !== "ADMIN" && user.role !== "SYSTEM_OWNER")) return;

    fetched.current = true;

    getMyTenant()
      .then((data) => {
        const pending: PendingDoc[] = data.pendingLegalDocs || [];
        if (pending.length > 0) {
          setDocs(pending);
          setShowModal(true);
        }
      })
      .catch(() => {});
  }, [loading]); // re-runs once loading flips to false

  if (!showModal || docs.length === 0) return null;

  const user = getUser();
  return (
    <LegalConsentModal
      docs={docs}
      userRole={user?.role || "OPERATOR"}
      onDone={() => setShowModal(false)}
    />
  );
}
